import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Oct 30 2018
 * @author BPo
 */
import * as React from 'react';
import { FormSpy } from 'react-final-form';
import { shouldRenderField } from '../Field/utils/shouldRenderField';
/**
 * This component is useful if you need to draw some static content when
 * some condition is valid. For example, you want to display help for the
 * form element only if the field has specific value. Or, you want to render
 * a modal if the checkbox is checked, and so..
 */

export var ConditionProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ConditionProvider, _React$PureComponent);

  function ConditionProvider() {
    _classCallCheck(this, ConditionProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConditionProvider).apply(this, arguments));
  }

  _createClass(ConditionProvider, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(FormSpy, {
        subscription: {
          values: true
        }
      }, function (form) {
        var values = form.values;

        if (shouldRenderField(_this.props.fieldHide, _this.props.fieldShow, values, _this.props.showIfPlaceholder, _this.props.placeholderValues)) {
          return _this.props.component();
        }

        return null;
      });
    }
  }]);

  return ConditionProvider;
}(React.PureComponent);